// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on (E23F1).
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '../../components/ui/page-header'
import { Tokens } from '../../features/account/Tokens'
import { meQuery } from '../../shared/org/me'
import { Part } from '../../shared/shell/StatePart'

export const Route = createFileRoute('/account/tokens')({
  staticData: { screenId: 'AccountTokensScreen', access: 'signed in' },
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(meQuery()),
  component: AccountTokensScreen,
})

function AccountTokensScreen() {
  const { t } = useTranslation()
  return (
    <main data-testid={ids.accountTokens.root} className="flex flex-col gap-(--stack-lg)">
      <PageHeader title={t('account.tokens.title')}>
        <p className="text-fg-muted">{t('account.tokens.lede')}</p>
      </PageHeader>
      <Part testId={ids.accountTokens.skeleton}>
        <Tokens />
      </Part>
    </main>
  )
}
